import axios from "@/plugins/axios";

let url = "/api/v1/me/nshop/orders";

/** @typedef {import('../../../../../store/nshop').NshopOrder} $NshopOrder */

export const orders = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, orders: $NshopOrder[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    gain: {
        /**
         * @param {{ _id: string }} data
         * @returns {Promise<{ order: $NshopOrder }>}
         */
        post(data) {
            return axios.post(`${url}/${data._id}/gain`).then((result) => result.data);
        },
    },

    stop: {
        /**
         * @param {{ _id: string }} data
         * @returns {Promise<{ order: $NshopOrder }>}
         */
        post(data) {
            return axios.post(`${url}/${data._id}/stop`).then((result) => result.data);
        },
    },
};

export default orders;
